import React from "react";
import * as ReactDOMClient from "react-dom/client";
import App, { queryClient } from "./App";
import { QueryClientProvider } from '@tanstack/react-query';

const container = document.getElementById("spektrixBookingPathway");

if (container) {
    ReactDOMClient.createRoot(container).render(
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    );
}
